import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Flex, Text } from '~/components/blocks';
import { PatientTypeIcon } from '~/components/partials';

import { ContactMethodType } from '../types';

type Props = {
  contactMethod: ContactMethodType;
  selected?: boolean;
  onClick?: () => void;
};

const Content = styled(Flex)<{ selected: boolean }>(({ theme, selected }) =>
  css({
    backgroundColor: selected ? theme.colors.background.default : theme.colors.background.bg,
    border: selected ? theme.borders.default : 'none',
    borderRadius: theme.radii.half,
    padding: selected
      ? `calc(${theme.space.xs} - 1px) calc(${theme.space.m} - 1px)`
      : `${theme.space.xs} ${theme.space.m}`,
    height: '100%',
    width: 'fit-content',
    textAlign: 'center',
    alignItems: 'center',
    marginRight: theme.space.s,
    cursor: selected ? 'default' : 'pointer',
    userSelect: 'none',
    '&:hover': {
      border: selected ? theme.borders.default : theme.borders.grey01,
      padding: `calc(${theme.space.xs} - 1px) calc(${theme.space.m} - 1px)`,
      boxShadow: selected ? 'none' : theme.shadows.default,
    },
  }),
);

export const ContactMethod = (props: Props) => {
  const { selected, contactMethod, onClick } = props;
  const isPatient = contactMethod === 'APP';
  const isLine = contactMethod === 'LINE';
  const label = isPatient ? 'アプリ' : isLine ? 'LINE' : 'SMS';

  return (
    <Content selected={!!selected} onClick={onClick}>
      <PatientTypeIcon isPatient={isPatient} isLine={isLine} size="l" />
      <Text size="s">{label}</Text>
    </Content>
  );
};
